import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { ProductSummary } from '@nucleus-commerce/api-client/admin';
import { Button } from '@nucleus-commerce/ui/components/button';
import { Card, CardContent } from '@nucleus-commerce/ui/components/card';

import type { StoreProductFormInput } from '../schemas/store-product-form-schema';

import { OverrideField } from './override-field';

/** Title, description and subtitle: what this store inherits from the master, or overrides. */
export function StoreBasicsCard({ master, settled }: { master: ProductSummary; settled: number }) {
  const { t } = useTranslation('storeCatalog');
  const { control, formState } = useFormContext<StoreProductFormInput>();
  const subtitle = useWatch({ control, name: 'subtitle' });
  const [adding, setAdding] = useState(false);
  const shown =
    adding || subtitle !== '' || Boolean(master.subtitle) || formState.errors.subtitle != null;

  return (
    <Card className="py-4" data-tour="store-catalog.product.overrides">
      <CardContent className="flex flex-col gap-4 px-4">
        <OverrideField
          name="title"
          label={t('fields.title')}
          master={master.title}
          settled={settled}
        />
        <OverrideField
          name="descriptionHtml"
          label={t('fields.description')}
          master={master.descriptionHtml}
          settled={settled}
          html
        />
        {shown ? (
          <OverrideField
            name="subtitle"
            label={t('fields.subtitle')}
            master={master.subtitle}
            settled={settled}
            startEditing={adding}
            placeholder={t('storePage.override.subtitlePlaceholder')}
            onRelease={() => setAdding(false)}
          />
        ) : formState.disabled ? null : (
          <div>
            <Button
              type="button"
              variant="link"
              size="xs"
              className="text-primary h-auto p-0 text-[13px]"
              onClick={() => setAdding(true)}
            >
              {t('storePage.override.addSubtitle')}
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
